<script>
export default {
  name: "AppliedFilters",
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activeFilters() {
      // Only keep filters that are non-empty
      return Object.fromEntries(
        Object.entries(this.filters).filter(([_, v]) => v && v.length > 0)
      );
    },
    hasFilters() {
      return Object.keys(this.activeFilters).length > 0;
    },
  },
};
</script>

<template>
  <div v-if="hasFilters" class="flex flex-wrap items-center gap-2 p-2">
    <!-- Individual filter chips -->
    <div
      v-for="(value, key) in activeFilters"
      :key="key"
      class="flex items-center bg-slate-200 dark:bg-slate-700 text-slate-800 dark:text-slate-100 text-sm px-3 py-1 rounded-full"
    >
      <span class="mr-2 capitalize">{{ key }}: {{ value }}</span>
      <button
        class="text-red-500 hover:text-red-700"
        @click="$emit('remove', key)"
      >
        ✕
      </button>
    </div>

    <!-- Clear all button -->
    <button
      class="ml-auto text-sm px-3 py-1 bg-red-500 text-white rounded-full hover:bg-red-600"
      @click="$emit('clear')"
    >
      Clear All
    </button>
  </div>
</template>


